import { destinationFields } from '~/utils/destinationPath';

import InteractionEvent, {
  type InteractionTargetType
} from './InteractionEvent';

export type NavigationLinkPlacement =
  | 'app_banner'
  | 'app_block'
  | 'app_modal'
  | 'auth_modal'
  | 'breadcrumb'
  | 'footer'
  | 'footer_app'
  | 'footer_social'
  | 'meganav'
  | 'module'
  | 'module_cta'
  | 'notification_nudge'
  | 'phone_menu'
  | 'product_information'
  | 'related_categories'
  | 'share'
  | 'social_strip';

export const MODULE_CTA_POSITION = 1;

export type NavigationLinkModuleType =
  | 'homepage-hot-deals'
  | 'homepage-marketplace-top-sellers'
  | 'homepage-popular-brands'
  | 'homepage-popular-products'
  | 'homepage-sub-brands'
  | 'homepage-top-categories'
  | 'homepage-upcoming-products';

export type NavigationLinkTargetProperties = {
  ancestor_labels?: string[];
  destination_path?: string;
  destination_url?: string;
  label?: string;
  module_position?: number;
  module_type?: NavigationLinkModuleType;
  placement: NavigationLinkPlacement;
  position: number;
};

type EventData = {
  ancestorLabels?: string[];
  gesture?: string;
  guestId?: string;
  href: string;
  isBot: boolean;
  label?: string;
  modulePosition?: number;
  moduleType?: NavigationLinkModuleType;
  placement: NavigationLinkPlacement;
  position: number;
};

class NavigationLinkInteractionEvent extends InteractionEvent<
  EventData,
  NavigationLinkTargetProperties
> {
  protected get targetType(): InteractionTargetType {
    return 'navigation_link';
  }

  protected get keepalive(): boolean {
    return true;
  }

  protected getTargetProperties(): NavigationLinkTargetProperties {
    return {
      ...destinationFields(this.data.href),
      ancestor_labels: this.data.ancestorLabels,
      label: this.data.label,
      module_position: this.data.modulePosition,
      module_type: this.data.moduleType,
      placement: this.data.placement,
      position: this.data.position
    };
  }
}

export default NavigationLinkInteractionEvent;
